import { render } from "./IntegracaoStatus.vue?vue&type=template&id=201e45de&scoped=true"
import script from "./IntegracaoStatus.vue?vue&type=script&lang=js"
export * from "./IntegracaoStatus.vue?vue&type=script&lang=js"

import "./IntegracaoStatus.vue?vue&type=style&index=0&id=201e45de&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201e45de"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSelect,QInput,QIcon,QPopupProxy,QDate,QBtn,QTable,QTd,QTooltip,QDialog,QCard,QCardSection,QSpace});qInstall(script, 'directives', {ClosePopup});
